module.exports = __webpack_public_path__ + "img/lock_options.289686a2.svg";